import { cookiesKeyNames } from "@revbox/common-fe";
import { getPubAbbr } from "@revbox/helpers-fe";
import { brandingPPCAuctionsLabels, statusLabels } from "@revbox/localization";
import { getPathKey } from "../../../../../contexts/CookiesContext";
import { TaxonomyModule } from "../../../../../modules/taxonomy";
import Cookies from "universal-cookie";

export function StatusRenderer({ value }) {
  if (!value) {
    return null;
  }
  const cookies = new Cookies()
  const pathKey = getPathKey()
  const language = cookies.get(pathKey)?.[cookiesKeyNames.language]?.value || 'EN'

    const statusMap = {
      PENDING: "badge bg-secondary w-100",
      LIVE: "badge bg-success w-100",
      INACTIVE: "badge bg-danger w-100",
      PAUSED: "badge bg-warning w-100",
      INHERITED: "badge bg-warning w-100",
      "BID ACTIVE": "badge bg-success w-100",
      OUTBID: "badge bg-warning w-100",
    };

    let status = value.split("@")[0]
    const translatedStatus = Object.entries(statusLabels[language]).find(([key, value]) => value === status);
    const statusKey = translatedStatus[0].toUpperCase();
    const statusValue = translatedStatus[1].toUpperCase();
    let views = Number(value.split("@")[1]);
    let className = statusMap[statusKey];

    // if (status === "LIVE") {
    //   status = "Bid Active".toUpperCase();
    // } 

    // if (views === 0) {
    //   status = "Inherited".toUpperCase();
    //   className = "badge bg-warning w-100";
    // }

    return className ? 
      <span className={className}>{statusValue}</span> : 
      <span className="badge bg-secondary w-100">{statusLabels[language]["Pending"].toUpperCase()}</span>;
}

export function StatusColumnHeaderTooltipRenderer() {
  const publisherIdByAbbr = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherIdByAbbr);

  let tooltip = taxonomy.tooltips.ppc_branding_column_headers.status;

  return tooltip;
}

export function StatusCellTooltipRenderer({ value }) {
  const cookies = new Cookies()
  const pathKey = getPathKey()
  const language = cookies.get(pathKey)?.[cookiesKeyNames.language]?.value || 'EN'

  const message = brandingPPCAuctionsLabels[language].yourStatus;  

  const publisherIdByAbbr = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherIdByAbbr);


  if (!value) {
    return null;
  }
  
  let status = value.split("@")[0]
  const translatedStatus = Object.entries(statusLabels[language]).find(([key, value]) => value === status);
  const statusKey = translatedStatus[0].toUpperCase();

  if (statusKey === statusLabels[language]["Live"]) {
    return taxonomy.tooltips.ppc_branding_column_inlines.status.live;
  }

  if (statusKey === statusLabels[language]["Inactive"]) {
    return taxonomy.tooltips.ppc_branding_column_inlines.status.inactive;
  }

  if (statusKey === statusLabels[language]["Pending"]) {
    return taxonomy.tooltips.ppc_branding_column_inlines.status.pending;
  }

  if (statusKey === statusLabels[language]["Paused"]) {
    return taxonomy.tooltips.ppc_branding_column_inlines.status.paused;
  }

  return message + " " + status;
}

  